export function pruneOrphanedSlots(schedules, tasks, 
/**
 * Ids we can PROVE were deleted — entity ids from the tombstone log.
 *
 * The guard that makes this a repair rather than a second bug. A slot is
 * removed only when something recorded the task's deletion. If a task is
 * missing with no tombstone, it did not go through a delete: it was lost —
 * by a stale overwrite, a bad merge, a half-written save — and its slot is
 * then the ONLY surviving trace that it ever existed. Tidying that away
 * destroys the evidence and makes the loss unrecoverable and invisible at
 * the same time.
 *
 * So: prove it, or leave it and say so.
 */
deletedIds) {
    const known = new Set(tasks.map((t) => t.id));
    let removed = 0;
    const dates = [];
    const unexplained = new Set();
    const next = schedules.map((schedule) => {
        const slots = schedule.scheduled_tasks ?? [];
        const kept = slots.filter((slot) => {
            // A buffer has no task to resolve, and is not a ghost.
            if (slot.is_buffer || !slot.task_id)
                return true;
            if (known.has(slot.task_id))
                return true;
            if (deletedIds.has(slot.task_id))
                return false;
            unexplained.add(slot.task_id);
            return true;
        });
        /**
         * `completed_tasks` is cleaned alongside. A finished task that was later
         * deleted would otherwise keep inflating the day's completed count while
         * nothing on the plan accounts for it.
         */
        const completed = schedule.completed_tasks ?? [];
        const keptCompleted = completed.filter((id) => known.has(id) || !deletedIds.has(id));
        if (kept.length === slots.length && keptCompleted.length === completed.length) {
            return schedule;
        }
        removed += slots.length - kept.length;
        dates.push(schedule.date);
        return { ...schedule, scheduled_tasks: kept, completed_tasks: keptCompleted };
    });
    return { schedules: next, removed, dates, unexplained: [...unexplained] };
}
//# sourceMappingURL=orphan-slots.js.map